<template>
  <div class="settingCon">
    <van-cell-group >
      <van-cell title="昵称" is-link value="修改昵称" class="barlist" center value-class="valCal"  @click="gotoPath('/updatename')" />
    </van-cell-group>
    <van-cell-group>
      <van-cell title="密码" is-link value="修改密码" class="barlist" center value-class="valCal"  @click="gotoPath('/updatepassword')"/>
    </van-cell-group>
    <van-cell-group>
      <van-cell title="手机号" is-link value="修改手机号" class="barlist" center value-class="valCal" @click="gotoPath('/updatephone')"/>
    </van-cell-group>
    <van-col span="24" type="flex" justify="space-between" class="barBtn">
      <van-button round type="danger" size="large" class="btn" @click="gotoPath('/login')">退出当前账号</van-button>
    </van-col>
  </div>
</template>
<script>
	export default {
    name:"settings",
    methods: {
      gotoPath(path){
        this.$router.push({
          path:path,
          name:path.substring(1)
        })
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/mixins.styl"
  .settingCon
    padding-top 8px
    .barlist
      background #ffffff
      color #222222
      height 98px
      padding-left 40px
      line-height 50px
      margin 8px 0px
      font-size 30px
      .valCal
        margin-right 10px
    .iconNext
      display inline-flex;
      display -webkit-inline-flex;
      width 13px
      height 23px
      background url("./images/xjt_btn.png") no-repeat center
      background-size 100% 100%
      color #bbb
      font-size 10px
      margin-left 20px
    .barBtn
      padding 80% 40px 0px
      .btn
        color #ffffff
        font-size 32px
        background #ff6d02
        height 88px
        line-height 88px
    .van-cell__left-icon, .van-cell__right-icon
      font-size 26px
      margin 0px 10px
</style>



// WEBPACK FOOTER //
// src/pages/Settings/Settings.vue